// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlClientCtx$LiteracyplanetClientFlags from "./GraphqlClientCtx.res.mjs";

function idleState() {
  return {
          loading: true,
          data: undefined,
          error: undefined
        };
}

var print = (function (q) {
      return q.definitions[0].name.value
    });

function Extend(Q) {
  var use = function (skip, variables) {
    var match = GraphqlClientCtx$LiteracyplanetClientFlags.use();
    var queryGraphqlAsync = match.queryGraphqlAsync;
    var match$1 = React.useState(function () {
          return {
                  loading: true,
                  data: undefined,
                  error: undefined
                };
        });
    var setResult = match$1[1];
    var result = match$1[0];
    var v = JSON.stringify(variables);
    var $$fetch = React.useCallback((async function () {
            if (result.loading) {
              
            } else {
              setResult(function (r) {
                    return {
                            loading: true,
                            data: r.data,
                            error: r.error
                          };
                  });
            }
            var match = await queryGraphqlAsync(Q.query, Q.serializeVariables(variables));
            var error = match.error;
            var data = match.data;
            return setResult(function (param) {
                        return {
                                loading: false,
                                data: Belt_Option.map(data, (function (d) {
                                        return Q.parse(d);
                                      })),
                                error: error
                              };
                      });
          }), [
          skip,
          v
        ]);
    React.useEffect((function () {
            var reset = function (param) {
              setResult(function (param) {
                    return {
                            loading: true,
                            data: undefined,
                            error: undefined
                          };
                  });
            };
            if (Belt_Option.getWithDefault(skip, false)) {
              reset();
            } else {
              $$fetch();
            }
          }), [
          skip,
          v
        ]);
    return [
            result,
            $$fetch
          ];
  };
  var useFetch = function () {
    var match = GraphqlClientCtx$LiteracyplanetClientFlags.use();
    var queryGraphqlAsync = match.queryGraphqlAsync;
    return async function (variables) {
      var match = await queryGraphqlAsync(Q.query, Q.serializeVariables(variables));
      return {
              data: Belt_Option.map(match.data, (function (d) {
                      return Q.parse(d);
                    })),
              error: match.error
            };
    };
  };
  return {
          use: use,
          useFetch: useFetch
        };
}

var Query = {
  idleState: idleState,
  print: print,
  Extend: Extend
};

function Extend$1(M) {
  var use = function () {
    var match = GraphqlClientCtx$LiteracyplanetClientFlags.use();
    var queryGraphqlAsync = match.queryGraphqlAsync;
    return async function (variables) {
      var match = await queryGraphqlAsync(M.query, M.serializeVariables(variables));
      return {
              data: Belt_Option.map(match.data, (function (d) {
                      return M.parse(d);
                    })),
              error: match.error
            };
    };
  };
  var useWithState = function () {
    var mutate = use();
    var match = React.useState(function () {
          return {
                  called: false,
                  loading: false,
                  data: undefined,
                  error: undefined
                };
        });
    var setResult = match[1];
    var mutation = async function (variables) {
      setResult(function (r) {
            return {
                    called: true,
                    loading: true,
                    data: r.data,
                    error: r.error
                  };
          });
      var match = await mutate(variables);
      var res_data = match.data;
      var res_error = match.error;
      var res = {
        called: true,
        loading: false,
        data: res_data,
        error: res_error
      };
      setResult(function (param) {
            return res;
          });
      return res;
    };
    return [
            mutation,
            match[0]
          ];
  };
  return {
          use: use,
          useWithState: useWithState
        };
}

var Mutation = {
  Extend: Extend$1
};

function Extend$2(S) {
  var use = function (_variables) {
    return {
            loading: true,
            data: undefined,
            error: undefined
          };
  };
  return {
          use: use
        };
}

var Subscription = {
  Extend: Extend$2
};

export {
  Query ,
  Mutation ,
  Subscription ,
}
/* react Not a pure module */
